import React from "react";
import { toast } from "react-toastify";

function FranklyToast({ toastId, type = "default", message, iconSrc, brandSrc }) {
    const W = 360;
    const H = 232;

    const TITLE_H = 36;
    const PAD = 12;

    const BODY_TOP = TITLE_H;
    const BODY_H = H - TITLE_H;

    const ICON_SIZE = 60;
    const CAPSULE_PAD = 5;

    const headerByType = {
        error: "Error",
        warning: "Warning!",
        success: "Success!",
        info: "Information",
        default: "Heads up!",
        inbox: "Inbox Update",
        stamp: "Framp Update",
        achievement: "Achievement Unlocked!",
    };

    const headerText = headerByType[type] || headerByType.default;

    return (
        <>
            {/* ── MOBILE: thin capsule (hidden at sm and above) ── */}
            <div className="block sm:hidden">
                <div
                    className="flex items-center bg-coal_dark border border-coal shadow-[0_6px_18px_rgba(0,0,0,0.45)]"
                    style={{
                        borderRadius: 16,
                        padding: CAPSULE_PAD,
                        paddingRight: 16,
                        gap: 10,
                        width: "90vw",
                        maxWidth: 360,
                    }}
                >
                    {/* Icon bubble */}
                    <div
                        className="flex-shrink-0 flex items-center justify-center overflow-hidden bg-coal rounded-xl"
                        style={{ width: ICON_SIZE, height: ICON_SIZE }}
                    >
                        {iconSrc ? (
                            <img
                                src={iconSrc}
                                alt=""
                                className={`w-full h-full object-contain ${type === "stamp" ? "brightness-0 invert opacity-80" : ""}`}
                                style={{ imageRendering: "pixelated" }}
                            />
                        ) : (
                            <img
                                src={`${process.env.PUBLIC_URL}/img/toasts/icon.png`}
                                className="w-[24px] h-[24px] opacity-60"
                                alt=""
                                style={{ imageRendering: "pixelated" }}
                            />
                        )}
                    </div>

                    {/* Text */}
                    <div className="flex flex-col min-w-0 flex-1">
                        <span className="font-['Jersey_10'] text-offwhite text-[18px] leading-[18px] mb-[3px]">
                            {headerText}
                        </span>
                        <span className="text-sm text-offwhite/80 truncate leading-tight">
                            {message}
                        </span>
                    </div>

                    {/* Close button */}
                    <button
                        type="button"
                        onClick={() => toast.dismiss(toastId)}
                        aria-label="Close"
                        className="flex-shrink-0 bg-offwhite border border-coal flex items-center justify-center text-coal_dark rounded-md w-[20px] h-[20px] ml-1"
                    >
                        ×
                    </button>
                </div>
            </div>

            {/* ── DESKTOP: full toast (hidden below sm) ── */}
            <div className="hidden sm:block">
                <div className="bg-transparent" style={{ width: W, height: H }}>
                    <div
                        className="relative overflow-hidden rounded-none bg-offwhite border border-coal shadow-[0_10px_22px_rgba(0,0,0,0.40)]"
                        style={{ width: W, height: H }}
                    >
                        <div
                            className="absolute left-0 top-0 right-0 flex items-center bg-coal_dark border-b border-coal"
                            style={{ height: TITLE_H, paddingLeft: PAD, paddingRight: PAD }}
                        >
                            <div className="flex-1 font-['Jersey_10'] flex flex-row gap-2 mt-2 text-offwhite/80 text-lg">
                                <img src={`${process.env.PUBLIC_URL}/img/toasts/icon.png`} className="h-[20px] w-[20px] mr-2" alt="" />
                                Frank&apos;s Messenger
                            </div>

                            <img src={`${process.env.PUBLIC_URL}/img/online.gif`} className="h-[16px] w-[40px] ml-auto mr-2" alt="" />
                            <button
                                type="button"
                                onClick={() => toast.dismiss(toastId)}
                                aria-label="Close"
                                className="bg-offwhite border border-coal flex items-center justify-center text-coal_dark w-[20px] h-[20px]"
                            >
                                ×
                            </button>
                        </div>

                        <div
                            className="absolute left-0 right-0 bg-gradient-to-b from-coal to-coal_dark"
                            style={{ top: BODY_TOP, height: BODY_H }}
                        >
                            <div className="absolute w-[100px] h-full">
                                <div className="flex items-center justify-center overflow-hidden h-full">
                                    {iconSrc ? (
                                        <img
                                            src={iconSrc}
                                            alt=""
                                            className={`${type === "stamp" ? "w-[66px] h-[66px]" : "w-[60px] h-[60px]"} relative -top-10 object-contain ${type === "stamp" ? "brightness-0 invert opacity-80" : ""}`}
                                            style={{ imageRendering: "pixelated" }}
                                        />
                                    ) : null}
                                </div>
                            </div>

                            <div className="absolute left-[100px] top-[34px] right-[20px]">
                                <div className="font-['Jersey_10'] text-offwhite text-[22px] leading-[22px] mb-[6px]">
                                    {headerText}
                                </div>

                                <div className="text-md text-offwhite/90 overflow-hidden text-ellipsis line-clamp-3">
                                    {message}
                                </div>
                            </div>

                            <div
                                className="absolute right-5 bottom-5"
                            >
                                {brandSrc ? (
                                    <img
                                        src={brandSrc}
                                        alt=""
                                        className="w-[32px] h-[31px] object-contain"
                                        style={{ imageRendering: "pixelated" }}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FranklyToast;